import WidgetStepPreview
  from '@components/Widgets/_global/WidgetStepPreview/WidgetStepPreview.vue'
import { mapState } from 'vuex'

export default {
  name: 'WidgetGallery',
  props: {
    widgetArr: {
      type: Array,
      required: true,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
    enableClone: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WidgetStepPreview,
  },
  data() {
    return {
      btnLoading: false,
    }
  },
  computed: {
    ...mapState('users', {
      isSuperuser: (state) => state.currentUser.isSuperuser,
    }),

    // Sorting widgets by priority
    sortedWidgets() {
      return this.widgetArr.slice().sort((a, b) => {
        let aPriority = a.priority
        let bPriority = b.priority

        // Treat '', null, or 0 as "no priority" by setting to Infinity
        aPriority = (aPriority && aPriority !== 0 && aPriority !== '')
          ? aPriority
          : Infinity
        bPriority = (bPriority && bPriority !== 0 && bPriority !== '')
          ? bPriority
          : Infinity

        return aPriority - bPriority
      })
    },
  },
  filters: {
    snakeToTitleCase(value) {
      if (!value) return ''
      return value
        .split('-')
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
        .join(' ')
    },
  },
  methods: {
    triggerChooseWidget(id) {
      this.$emit('choose-widget', id)
    },
    triggerPreviewWidget(id) {
      if (this.btnLoading) return
      this.btnLoading = true
      this.$emit('preview-widget', id)
      this.btnLoading = false
    },
    triggerCloneWidget() {
      if (this.btnLoading) return
      this.btnLoading = true
      this.$emit('clone-widget')
      this.btnLoading = false
    },
  },
}